<template lang="pug">
.smart__background(id='smart')
  .smart
    .smart__title SMART TV
    .smart__subtitle Подключение к SMART TV
    .smart__item-list
      .smart__item
        .smart__img-block
          img.smart__img(src='../static/smart1.svg')
        .smart__count 1
        .smart__text Установите YouTube на телефон или планшет
      
      .smart__item
        .smart__img-block
          img.smart__img(src='../static/smart2.svg')
        .smart__count 2
        .smart__text Подключите телефон/планшет и TV к одной сети wi-fi
      
      .smart__item
        .smart__img-block
          img.smart__img(src='../static/smart3.svg')
        .smart__count 3
        .smart__text Откройте ссылку и перейдите к трансляции на Youtube
      
      .smart__item
        .smart__img-block
          img.smart__img(src='../static/smart4.svg')
        .smart__count 4
        .smart__text Нажмите на символ в верхнем правом углу окна видео-плеера
      
      .smart__item
        .smart__img-block
          img.smart__img(src='../static/smart5.svg')
        .smart__count 5
        .smart__text Выберите модель телевизора из списка, дождитесь установления подключения
      
      .smart__item
        .smart__img-block
          img.smart__img(src='../static/smart6.svg')
        .smart__count 6
        .smart__text Наслаждайтесь полным погружением в атмосферу
</template>

<script>
export default {
  name: 'smart',
};
</script>

<style lang="sass">
.smart
  padding: 97px 20px 26px
  max-width: 954px
  margin: 0 auto
  display: flex
  flex-direction: column
  @media screen and (max-width: 812px)
    padding: 60px 20px
    align-items: center
    max-width: 375px

  &__background
    background: white

  &__title
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    letter-spacing: 2px;
    text-align: center
    color: #B3B3B3;
    margin-bottom: 67px
    font-weight: bold
    @media screen and (max-width: 812px)
      margin-bottom: 40px
  &__subtitle
    font-size: 48px;
    line-height: 56px;
    text-align: center
    color: #666666;
    margin-bottom: 67px
    @media screen and (max-width: 812px)
      font-size: 40px;
      line-height: 47px;
      margin-bottom: 40px
  &__item
    margin-bottom: 60px
    display: flex
    flex-direction: column
    align-items: center
    width: 246px
    max-width: 246px
    @media screen and (max-width: 812px)
      max-width: none
      width: auto
      margin-bottom: 40px
    &-list
      display: flex
      flex-wrap: wrap
      justify-content: space-between
      @media screen and (max-width: 812px)
        justify-content: center
  &__img
    &-block
      height: 73px
      margin-bottom: 45px
      @media screen and (max-width: 812px)
        height: auto
        margin-bottom: 15px
  &__count
    font-size: 14px;
    line-height: 30px;
    text-align: center;
    color: #000000;
    position: relative
    width: 30px
    height: 30px
    text-align: center
    @media screen and (max-width: 812px)
      font-size: 15px;
      line-height: 30px;
    &::before
      content: ''
      position: absolute
      background: #304FFE
      top: -2px
      width: 30px
      height: 2px
      transform: translateX(-40%)
      @media screen and (max-width: 812px)
        top: -5px
        transform: translateX(-38%)
  &__text
    font-size: 14px;
    line-height: 30px;
    text-align: center;
    color: #999999;
    @media screen and (max-width: 812px)
      max-width: 277px
      font-size: 15px;
      line-height: 22px;
</style>
